/** Number of rows displayed per pagination page. */
export const PAGE_SIZE = 10;

/**
 * Maps every common Vietnamese accented character to its unaccented base.
 * Used by normalizeText() so that a user typing "can" matches rows containing "Cần", "Căn", "Cán", etc.
 */
export const DIACRITICS_MAP: Record<string, string> = {
  // a variants
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ả: "a",
  ạ: "a",
  ầ: "a",
  ấ: "a",
  ẫ: "a",
  ẩ: "a",
  ậ: "a",
  ằ: "a",
  ắ: "a",
  ẵ: "a",
  ẳ: "a",
  ặ: "a",
  ă: "a",
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ả: "A",
  Ạ: "A",
  Ầ: "A",
  Ấ: "A",
  Ẫ: "A",
  Ẩ: "A",
  Ậ: "A",
  Ằ: "A",
  Ắ: "A",
  Ẵ: "A",
  Ẳ: "A",
  Ặ: "A",
  Ă: "A",
  // e variants
  è: "e",
  é: "e",
  ê: "e",
  ẽ: "e",
  ẻ: "e",
  ẹ: "e",
  ề: "e",
  ế: "e",
  ễ: "e",
  ể: "e",
  ệ: "e",
  È: "E",
  É: "E",
  Ê: "E",
  Ẽ: "E",
  Ẻ: "E",
  Ẹ: "E",
  Ề: "E",
  Ế: "E",
  Ễ: "E",
  Ể: "E",
  Ệ: "E",
  // i variants
  ì: "i",
  í: "i",
  ĩ: "i",
  ỉ: "i",
  ị: "i",
  Ì: "I",
  Í: "I",
  Ĩ: "I",
  Ỉ: "I",
  Ị: "I",
  // o variants
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ỏ: "o",
  ọ: "o",
  ồ: "o",
  ố: "o",
  ỗ: "o",
  ổ: "o",
  ộ: "o",
  ờ: "o",
  ớ: "o",
  ỡ: "o",
  ở: "o",
  ợ: "o",
  ơ: "o",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ỏ: "O",
  Ọ: "O",
  Ồ: "O",
  Ố: "O",
  Ỗ: "O",
  Ổ: "O",
  Ộ: "O",
  Ờ: "O",
  Ớ: "O",
  Ỡ: "O",
  Ở: "O",
  Ợ: "O",
  Ơ: "O",
  // u variants
  ù: "u",
  ú: "u",
  ũ: "u",
  ủ: "u",
  ụ: "u",
  ừ: "u",
  ứ: "u",
  ữ: "u",
  ử: "u",
  ự: "u",
  ư: "u",
  Ù: "U",
  Ú: "U",
  Ũ: "U",
  Ủ: "U",
  Ụ: "U",
  Ừ: "U",
  Ứ: "U",
  Ữ: "U",
  Ử: "U",
  Ự: "U",
  Ư: "U",
  // y variants
  ỳ: "y",
  ý: "y",
  ỹ: "y",
  ỷ: "y",
  ỵ: "y",
  Ỳ: "Y",
  Ý: "Y",
  Ỹ: "Y",
  Ỷ: "Y",
  Ỵ: "Y",
  // d variants
  đ: "d",
  Đ: "D",
};
